import { render, staticRenderFns } from "./AffiliatesSign.vue?vue&type=template&id=23e089bc&scoped=true&"
import script from "./AffiliatesSign.vue?vue&type=script&lang=js&"
export * from "./AffiliatesSign.vue?vue&type=script&lang=js&"
import style0 from "./AffiliatesSign.vue?vue&type=style&index=0&id=23e089bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e089bc",
  null
  
)

export default component.exports